// TODO: Figure logout reducer so it doesn't require user
import {
  LOGIN_SUCCESSFUL,
  LOGOUT,
  logout,
} from 'portal-modules/auth/redux/modules/user'
import { takeLatest, call, put } from 'redux-saga/effects'
import Api from '../../api'
import { handleResponseError } from '../create-request-saga'
import { addError } from 'portal-modules/common/redux/modules/errors'
import errorCodes from 'portal-modules/common/constants/error-codes'
import { FORCE_LOGOUT } from 'portal-modules/common/constants/keys'
import { localStorage as local } from '@entrata/utils'
import { CLEAR_COMPANY_LINKS } from 'portal-modules/company-links/redux/modules/companyLinks'
import { receivePropertyAssociation } from 'portal-modules/common/redux/modules/propertyAssociation'
import { requestBalanceDue } from 'portal-modules/common/redux/modules/balanceDue'
import getPaymentSourceCondition from 'portal-modules/common/utils/get-payment-source-condition'

// Checking payment source condition for colleen payment
const { isColleenPayment }= getPaymentSourceCondition()

export const apartmentPermissionsSelector = (my_apartment, entity) =>
  (my_apartment?.enabled &&
    my_apartment?.my_apartment_permissions &&
    entity?.enabled) ||
  false

// action types
const RECEIVE_PRODUCT_PERMISSIONS =
  'rp/productPermissions/RECEIVE_PRODUCT_PERMISSIONS'
const REQUEST_PRODUCT_PERMISSIONS =
  'rp/productPermissions/REQUEST_PRODUCT_PERMISSIONS'
const REQUEST_TENANT_PRODUCT_PERMISSIONS =
  'tp/productPermissions/REQUEST_TENANT_PRODUCT_PERMISSIONS'
const REQUEST_PROPERTY_PRODUCT_PERMISSIONS =
  'rp/productPermissions/REQUEST_PROPERTY_PRODUCT_PERMISSIONS'
const RECEIVE_PROPERTY_PRODUCT_PERMISSIONS =
  'rp/productPermissions/RECEIVE_PROPERTY_PRODUCT_PERMISSIONS'

// reducer
export default (state = { requested: false }, { type, payload }) => {
  switch (type) {
    case RECEIVE_PRODUCT_PERMISSIONS:
      return { ...state, ...payload, requested: true }
    case RECEIVE_PROPERTY_PRODUCT_PERMISSIONS:
      return { ...payload }
    case LOGIN_SUCCESSFUL:
      return payload.productPermissions
        ? { ...state, ...payload.productPermissions, requested: true }
        : state
    case LOGOUT:
      return {}
    default:
      return state
  }
}

// action creators
export const requestProductPermissions = () => ({
  type: REQUEST_PRODUCT_PERMISSIONS,
})

export const requestTenantProductPermissions = () => ({
  type: REQUEST_TENANT_PRODUCT_PERMISSIONS,
})

export const receiveProductPermissions = payload => ({
  type: RECEIVE_PRODUCT_PERMISSIONS,
  payload,
})

export const requestPropertyProductPermissions = payload => ({
  type: REQUEST_PROPERTY_PRODUCT_PERMISSIONS,
  payload,
})

export const receivePropertyProductPermissions = payload => ({
  type: RECEIVE_PROPERTY_PRODUCT_PERMISSIONS,
  payload,
})

// sagas
function* fetchProductPermissions() {
  try {
    let {
      code = 0,
      message,
      product_permissions = {},
      contact_permissons = {},
    } = yield call(Api.getProductPermissions)
    if (
      code == errorCodes.LEASE_NOT_FOUND ||
      code == errorCodes.RECORD_NOT_FOUND
    ) {
      local.set(FORCE_LOGOUT, 1)
      yield put(logout())
      yield put(addError({ key: 'login', message }))
    }

    product_permissions = {
      ...Api.flattenPermissions(product_permissions),
      contact_permissons,
    }

    yield put(receiveProductPermissions(product_permissions))
    // Fetch balance due only for colleen payment
    isColleenPayment && (yield put(requestBalanceDue()))
    
  } catch (error) {
    yield call(handleResponseError, error, { key: 'permissions' })
  }
}

function* fetchTenantProductPermissions() {
  try {
    let product_permissions = {}
    product_permissions = yield call(Api.getTenantProductPermissions)

    const { contact_permissons, icp_licence_number, ...permissions } =
      product_permissions

    product_permissions = {
      ...Api.flattenPermissions(permissions),
      contact_permissons,
      icp_licence_number,
    }

    yield put(receiveProductPermissions(product_permissions))
  } catch (error) {
    yield call(handleResponseError, error, { key: 'permissions' })
  }
}

function* fetchPropertyProductPermissions({ payload }) {
  try {
    const response = yield call(Api.getPropertyProductPermissions)
    yield put(receivePropertyAssociation(response))
    if (!payload) {
      yield put(receivePropertyProductPermissions(response))
      yield put({ type: CLEAR_COMPANY_LINKS })
    }

    typeof payload?.callback === 'function' && payload?.callback(response)
  } catch (error) {
    yield call(handleResponseError, error, { key: 'permissions' })
  }
}

function* watchPermissions() {
  yield takeLatest(REQUEST_PRODUCT_PERMISSIONS, fetchProductPermissions)
}

function* watchTenantPermissions() {
  yield takeLatest(
    REQUEST_TENANT_PRODUCT_PERMISSIONS,
    fetchTenantProductPermissions,
  )
}

function* watchPropertyProductPermissions() {
  yield takeLatest(
    REQUEST_PROPERTY_PRODUCT_PERMISSIONS,
    fetchPropertyProductPermissions,
  )
}

export const sagas = [
  watchPermissions,
  watchTenantPermissions,
  watchPropertyProductPermissions,
]
